import script from "./AppInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AppInfo.vue?vue&type=script&setup=true&lang=js"

export default script